{
  "signup": {
    "preview": "確認您的電郵地址以啟動您的 BidNova Auctions 帳戶",
    "heading": "確認您的電郵地址",
    "body1": "歡迎加入 BidNova Auctions——英國首屈一指的評級 Pokémon 卡牌交易平台。",
    "body2": "請確認您的電郵地址{recipientSuffix}以啟動帳戶，並開始以英鎊競投。",
    "recipientSuffix": "（{recipient}）",
    "cta": "驗證電郵地址",
    "footer": "此連結僅限使用一次，將於短時間內失效。如您並未建立帳戶，請忽略此電郵。",
    "subject": "確認你的電郵"
  },
  "recovery": {
    "preview": "重設您的 BidNova Auctions 密碼",
    "heading": "重設密碼",
    "body1": "我們收到您在 BidNova Auctions 帳戶重設密碼的請求。請按下方按鈕設定新密碼。",
    "cta": "重設密碼",
    "footer": "此連結僅限使用一次，將於短時間內失效。如您並未提出重設密碼要求，可忽略此電郵——您的密碼將不會被更改。",
    "subject": "重設你的密碼"
  },
  "magicLink": {
    "preview": "您的 BidNova Auctions 登入連結",
    "heading": "您的登入連結",
    "body": "請按下方按鈕登入 BidNova Auctions。此連結將於短時間內失效。",
    "cta": "登入",
    "footer": "如您並未要求此連結，可安全地忽略此電郵。",
    "subject": "你的登入連結"
  },
  "emailChange": {
    "preview": "確認您於 {siteName} 的電郵地址變更",
    "heading": "確認電郵地址變更",
    "body1": "您要求將 {siteName} 的電郵地址由 {oldEmail} 更改為 {newEmail}。",
    "body2": "請按下方按鈕確認此項變更：",
    "cta": "確認電郵變更",
    "footer": "如您並未提出此項變更，請立即保護您的帳戶。",
    "subject": "確認你的新電郵"
  },
  "reauthentication": {
    "preview": "您的驗證碼",
    "heading": "確認重新驗證身份",
    "body": "請使用以下驗證碼確認您的身份：",
    "footer": "此驗證碼將於短時間內失效。如您並未提出此要求，可安全地忽略此電郵。",
    "subject": "你的驗證碼"
  },
  "invite": {
    "preview": "您已獲邀加入 {siteName}",
    "heading": "您已獲邀請",
    "body": "您已獲邀加入 {siteName}。請按下方按鈕接受邀請並建立帳戶。",
    "cta": "接受邀請",
    "footer": "如您並非預期收到此邀請，可安全地忽略此電郵。",
    "subject": "你已獲邀請"
  },
  "newBidReceived": {
    "preview": "{auctionTitle} 有新出價",
    "previewFallback": "您的拍賣有新出價",
    "heading": "您收到新出價",
    "bidderFallback": "一位收藏家",
    "auctionFallback": "您的拍賣項目",
    "body": "{bidder}剛就 {auctionTitle} 出價。",
    "keyValueLabel": "目前最高出價",
    "bodyWatch": "即時留意拍賣動態，緊貼倒數計時的最新出價情況。",
    "cta": "查看拍賣",
    "subject": "{auctionTitle} 有新出價",
    "subjectFallback": "您有新的出價"
  },
  "outbid": {
    "preview": "您的出價已被超越",
    "heading": "您的出價已被超越",
    "auctionFallback": "一場拍賣",
    "body": "有人就 {auctionTitle} 出了更高的價錢。",
    "keyValueLabel": "目前最高出價",
    "bodyJump": "把握時間，在倒數結束前重新出價。",
    "cta": "出更高價",
    "subject": "您於 {auctionTitle} 的出價已被超越"
  },
  "auctionWon": {
    "preview": "您成功得標！請完成付款以確保成功購得此卡。",
    "heading": "您成功得標 🏆",
    "auctionFallback": "此拍賣",
    "body1": "恭喜您——您成功得標 {auctionTitle}。",
    "body2": "請於 48 小時內完成付款，以確認訂單並安排出貨。",
    "cta": "立即付款",
    "subject": "您得標 {auctionTitle}——需要付款"
  },
  "auctionLost": {
    "preview": "拍賣已結束",
    "heading": "拍賣已結束",
    "auctionFallback": "此拍賣",
    "auctionFallbackShort": "一場拍賣",
    "bodyDefault": "很可惜，您於 {auctionTitle} 的出價並非最終得標出價。",
    "bodyMore": "更多評級珍藏即將上架——立即再看看。",
    "cta": "瀏覽即時拍賣",
    "subject": "拍賣已結束：{auctionTitle}"
  },
  "auctionEndingSoon": {
    "preview": "您關注的拍賣即將結束",
    "heading": "即將結束",
    "auctionFallback": "一場拍賣",
    "endsInFallback": "1 小時",
    "body": "{auctionTitle} 將於 {endsIn}後結束。",
    "keyValueLabel": "目前最高出價",
    "cta": "立即出價",
    "subject": "即將結束：{auctionTitle}"
  },
  "orderCreated": {
    "preview": "有買家需要為您的商品付款",
    "heading": "訂單已建立",
    "auctionFallback": "listing",
    "bodyWithAmount": "您的拍賣 {auctionTitle} 已結束，得標出價為 {amount}。",
    "bodyNoAmount": "您的拍賣 {auctionTitle} 已結束並產生得標出價。",
    "body2": "買家完成付款後，我們將再次通知您，屆時您便可安排出貨並將訂單標記為已寄出。",
    "cta": "前往控制台",
    "subject": "{auctionTitle} 的訂單已建立"
  },
  "orderPaid": {
    "preview": "付款已確認",
    "heading": "付款已確認",
    "orderFallback": "您的訂單",
    "bodyWithAmount": "您就 {auctionTitle} 支付的 {amount} 已確認收訖。",
    "bodyNoAmount": "您就 {auctionTitle} 的付款已確認收訖。",
    "body2": "賣家已收到通知並將盡快安排出貨。物流編號一經提供，我們會另行電郵通知您。",
    "body3WithNumber": "您的收據（{invoiceNumber}）已附上，亦可隨時於「我的訂單」頁面查閱。",
    "body3NoNumber": "您的收據已附上，亦可隨時於「我的訂單」頁面查閱。",
    "ctaReceipt": "下載收據（PDF）",
    "ctaOrder": "查看訂單",
    "subject": "{auctionTitle} 的付款已確認"
  },
  "orderCompleted": {
    "preview": "訂單已完成——{auctionTitle}",
    "heading": "訂單已完成",
    "cardFallback": "此卡",
    "bodySeller": "您就 {auctionTitle} 的訂單現已完全完成。您的款項已發放，買家亦已留下評價。",
    "bodyBuyer": "您就 {auctionTitle} 的訂單現已完全完成。賣家已收到款項，交易已結束。",
    "keyValueLabel": "訂單總額",
    "body2": "感謝您使用 BidNova Auctions。歡迎留下評價，幫助其他收藏家及賣家。",
    "cta": "查看訂單",
    "subjectWithTitle": "訂單已完成——{auctionTitle}",
    "subjectFallback": "您的訂單已完成"
  },
  "paymentReceivedSeller": {
    "preview": "您已收款——請安排出貨",
    "heading": "已收到付款",
    "listingFallback": "您的上架項目",
    "bodyWithAmount": "好消息——買家已就 {auctionTitle} 支付 {amount}。",
    "bodyNoAmount": "好消息——買家已就 {auctionTitle} 完成付款。",
    "body2": "請於 3 個工作天內安排出貨，並填寫物流編號將訂單標記為已寄出。",
    "body3WithNumber": "您的銷售發票（{invoiceNumber}）已提供，亦可於賣家控制台查閱。",
    "body3NoNumber": "您的銷售發票已提供，亦可於賣家控制台查閱。",
    "ctaInvoice": "下載發票（PDF）",
    "ctaDashboard": "前往賣家控制台",
    "subject": "已收到 {auctionTitle} 的付款——請盡快出貨"
  },
  "itemShipped": {
    "preview": "您的訂單已寄出",
    "heading": "您的訂單正在運送中",
    "cardFallback": "您的卡牌",
    "body1": "{auctionTitle} 已由賣家寄出。",
    "keyValueLabel": "物流編號",
    "body2": "貨件送達後，請於訂單頁面確認收貨，以便賣家可以收到款項。",
    "cta": "查看訂單",
    "subject": "已寄出：{auctionTitle}",
    "orderFallback": "您的訂單"
  },
  "trackingAvailable": {
    "preview": "您的 Royal Mail 物流編號已備妥",
    "heading": "您的物流編號已備妥",
    "orderFallback": "您的訂單",
    "carrierFallback": "Royal Mail",
    "body1": "{auctionTitle} 的運送標籤已建立，賣家將盡快交予 {carrier} 處理。",
    "keyValueLabel": "物流編號",
    "cta": "追蹤包裹",
    "footer": "您亦可隨時於 {ordersUrl} 查看訂單及物流狀態。",
    "subject": "{auctionTitle} 的物流編號"
  },
  "deliveryConfirmed": {
    "preview": "買家已確認收貨",
    "heading": "已確認收貨",
    "cardFallback": "此卡",
    "saleFallback": "此宗銷售",
    "body1": "買家已確認收到 {auctionTitle}。",
    "body2": "我們團隊將於短時間內發放您的款項（已扣除 8% 平台佣金）。",
    "cta": "前往控制台",
    "subject": "{auctionTitle} 已確認收貨"
  },
  "sellerPayout": {
    "preview": "您的款項已發放",
    "heading": "款項已發放",
    "saleFallback": "此宗銷售",
    "bodyWithAmount": "您就 {auctionTitle} 的款項 {amount} 已發放至您的 Stripe 帳戶。",
    "bodyNoAmount": "您就 {auctionTitle} 的款項已發放至您的 Stripe 帳戶。",
    "keyValueLabel": "付款參考編號",
    "footer": "款項一般於 1 至 2 個工作天內到帳。",
    "cta": "前往控制台",
    "subject": "{auctionTitle} 的款項已發放"
  },
  "refundCompleted": {
    "heading": "退款已完成",
    "bodySeller": "您其中一張訂單的退款已完成。",
    "bodyBuyer": "您的退款已完成，款項將於短時間內退回原付款方式。",
    "itemLabel": "商品",
    "amountLabel": "金額",
    "cta": "查看訂單",
    "subject": "退款已完成"
  },
  "listingApproved": {
    "preview": "您的上架項目已成功刊登",
    "heading": "您的上架項目已獲批准",
    "listingFallback": "您的上架項目",
    "body": "{auctionTitle} 已獲批准並已於 BidNova 上架。",
    "cta": "查看上架項目",
    "subject": "上架項目已獲批准：{auctionTitle}",
    "itemFallback": "您的商品"
  },
  "listingRejected": {
    "preview": "上架項目需要修改",
    "heading": "上架項目需要修改",
    "body": "您提交的上架項目 {auctionTitle} 未能獲得批准。",
    "reasonLabel": "原因",
    "body2": "您可於賣家控制台修改並重新提交。",
    "cta": "修改上架項目",
    "subject": "上架項目需要修改：{auctionTitle}",
    "itemFallback": "您的商品"
  },
  "welcome": {
    "preview": "歡迎加入 BidNova Auctions",
    "headingWithName": "歡迎，{displayName}！",
    "headingPlain": "歡迎！",
    "body1": "感謝您加入 BidNova Auctions——英國首屈一指的評級 Pokémon 卡牌交易平台。",
    "body2": "立即瀏覽即時拍賣，以英鎊出價，尋回您一直在追尋的珍藏。",
    "cta": "瀏覽即時拍賣",
    "footer": "同時也想寄賣？請於控制台完成 Stripe 驗證，即可上架首張卡牌。",
    "subject": "歡迎加入 BidNova Auctions"
  },
  "disputeNotification": {
    "headlineDefault": "爭議更新",
    "introDefault": "您的訂單有一宗爭議個案出現最新進展。",
    "orderLabel": "訂單",
    "itemLabel": "商品",
    "statusLabel": "爭議狀態",
    "actionRequiredLabel": "需要採取的行動",
    "notAvailable": "—",
    "cta": "查看爭議個案",
    "footer": "您收到此電郵，因為您是此爭議個案的一方。所有詳情、訊息及證據均可於「爭議中心」隨時查閱。",
    "subjectDefault": "爭議更新"
  },
  "watchlistNewBid": {
    "preview": "您關注的拍賣有新出價",
    "heading": "您關注的拍賣有新出價",
    "auctionFallback": "您關注的一場拍賣",
    "body": "{auctionTitle} 有新的出價。",
    "keyValueLabel": "目前最高出價",
    "cta": "查看拍賣",
    "subject": "{auctionTitle} 有新出價",
    "subjectFallback": "您關注的一場拍賣"
  },
  "auctionBelowReserve": {
    "preview": "您的拍賣未達底價",
    "heading": "拍賣結束但未達底價",
    "auctionFallback": "您的拍賣",
    "body": "您的listing {auctionTitle} 已結束，惟未達底價，故未能完成交易。",
    "highestBidLabel": "最高出價",
    "reserveLabel": "底價",
    "body2": "您可隨時於賣家控制台重新上架此商品。",
    "cta": "重新上架",
    "subject": "{auctionTitle} 未達底價"
  },
  "paymentReminder": {
    "preview": "提醒您完成得標付款",
    "heading": "付款提醒",
    "orderFallback": "您的訂單",
    "bodyWithAmount": "您仍需完成 {auctionTitle} 的付款（{amount}）。",
    "bodyNoAmount": "您仍需完成 {auctionTitle} 的付款。",
    "body2": "逾期未付款的訂單可能會被取消，並轉予次高出價者。",
    "cta": "立即付款",
    "subject": "提醒：請盡快為 {auctionTitle} 付款"
  },
  "adminAlert": {
    "subjectFallback": "平台警示",
    "body": "BidNova Auctions 有一項事件需要您留意。",
    "cta": "前往管理控制台",
    "subjectPrefix": "[BidNova Auctions] {subject}"
  }
}